

























import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IZone } from "../../models/interfaces/zone/zone.model.interface";

@Component({
  components: {
  }
})
export default class ZoneTag extends Vue {

  @Prop() public zone: IZone;

  private show: boolean = false;

  get getHead(): string {
    const head = `<script>
      (function () {window['_tla'] = window['_tla'] || function () {
      (window['_tla'].queue = window['_tla'].queue || []).push(arguments);
      }, window['_tla'].timestamp = 1 * new Date(); })();
      _tla('create', '${this.zone.property.propertyCode}'); _tla('track', 'page');
&lt;/script>
<script type="text/javascript" async src="http://pub.uk-tla.com/files/tla.js">&lt;/script>`;
    return head;
  }

  get getBody(): string {
    const body = `<div id="tla_zone_${this.zone.code}"><script>_tla('getContent', '${this.zone.code}', 'tla_zone_${this.zone.code}');&lt;/script></div>`;
    return body;
  }

  public showModal() {
    this.show = true;
  }

  public hideModal() {
    this.show = false;
  }

}
